import React from 'react';
import ReadingAidDynamic from '../components/reading-aid/reading-aid-dynamic';

const ReadingAidBlock = (props) => <ReadingAidDynamic {...props} />;

export default ReadingAidBlock;
